import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

export function Loading({
  isFullHeight = true,
  spinnerSize = 32,
  pathSize = 8,
  padding = 8,
  transparent = true,
  progress = 0,
  showProgress = false,
}) {
  return (
    <div
      className={classNames(
        "flex justify-center items-center",
        { "h-screen": isFullHeight },
        { "bg-transparent": transparent },
        { "dark:bg-slate-900": !transparent },
      )}
      style={{ padding: `${padding * 0.25}rem` }}
    >
      <div
        className="animate-spin ease-linear rounded-full border-gray-100 border-t-[#7d3aed] dark:border-slate-700 dark:border-t-[#7d3aed]"
        style={{
          width: `${spinnerSize * 0.25}rem`,
          height: `${spinnerSize * 0.25}rem`,
          borderWidth: `${pathSize * 0.25}rem`,
        }}
      />
      {showProgress && <span className="absolute text-gray-700 dark:text-slate-200">{progress}%</span>}
    </div>
  );
}

Loading.propTypes = {
  isFullHeight: PropTypes.bool,
  spinnerSize: PropTypes.number,
  pathSize: PropTypes.number,
  padding: PropTypes.number,
  transparent: PropTypes.bool,
  progress: PropTypes.number,
  showProgress: PropTypes.bool,
};
